/**
 * Datos mock para la aplicación demo
 * Todos los datos están relacionados y son coherentes entre sí
 */

// 🔹 Fideicomisos disponibles
export const FIDEICOMISOS = [
  {
    id: 1,
    name: "Fideicomiso Plazas Metropolitanas",
    gestor: "Devise Capital",
    administrador: "Acción Fiduciaria",
    tipo: "Comercial",
    categoria: "Comercial",
    descripcion: "Fideicomiso enfocado en desarrollo de plazas comerciales, centros de negocios y locales comerciales en zonas estratégicas con alta rentabilidad y estabilidad a largo plazo.",
    valor_unidad: 100000, // Valor de cada unidad en COP
    tir_anual: 10, // TIR anual en porcentaje
    color: "#B9DE2C",
    imagen: require("../assets/images/logoamarillo.jpg"),
    unidades_disponibles: 100000000,
    nuevo: false
  },
  {
    id: 2,
    name: "Fideicomiso Bodegas Centrales",
    gestor: "Inversiones Eco",
    administrador: "Acción Fiduciaria",
    tipo: "Logístico",
    categoria: "Logístico",
    descripcion: "Fideicomiso especializado en proyectos de bodegas logísticas, centros de distribución y almacenamiento con ubicaciones estratégicas para el comercio nacional e internacional.",
    valor_unidad: 100000,
    tir_anual: 10,
    color: "#00F5D4",
    imagen: require("../assets/images/logoverde.jpg"),
    unidades_disponibles: 100000000,
    nuevo: false
  },
  {
    id: 3,
    name: "Fideicomiso Vivienda Urbana",
    gestor: "Oceanic Partners",
    administrador: "Acción Fiduciaria",
    tipo: "Residencial",
    categoria: "Residencial",
    descripcion: "Fideicomiso dedicado a desarrollos habitacionales, apartamentos y proyectos de vivienda de interés prioritario (VIP) en ubicaciones estratégicas con alta demanda y proyección de crecimiento.",
    valor_unidad: 100000,
    tir_anual: 10,
    color: "#557BD1",
    imagen: require("../assets/images/logoazul.jpg"),
    unidades_disponibles: 100000000,
    nuevo: false
  },
  {
    id: 4,
    name: "Fideicomiso Torres Corporativas",
    gestor: "TechVentures Capital",
    administrador: "Acción Fiduciaria",
    tipo: "Oficinas",
    categoria: "Oficinas",
    descripcion: "Fideicomiso enfocado en edificios corporativos y espacios de oficinas premium con tecnología de punta, diseñados para empresas y multinacionales en zonas empresariales estratégicas.",
    valor_unidad: 150000,
    tir_anual: 15,
    color: "#9B59B6",
    imagen: require("../assets/images/TechInnovation.jpg"),
    unidades_disponibles: 50000000,
    nuevo: true,
    negociable: false
  },
  {
    id: 5,
    name: "Fideicomiso Destinos Hoteleros",
    gestor: "BuildCo Infrastructure",
    administrador: "Acción Fiduciaria",
    tipo: "Hotelero",
    categoria: "Hotelero",
    descripcion: "Fideicomiso especializado en proyectos hoteleros, desarrollos turísticos y espacios de hospedaje en ubicaciones estratégicas con alto flujo de visitantes y potencial de crecimiento en el sector turismo.",
    valor_unidad: 120000,
    tir_anual: 12,
    color: "#E67E22",
    imagen: require("../assets/images/InfraestructuraVial.jpg"),
    unidades_disponibles: 75000000,
    nuevo: false,
    negociable: true
  },
  {
    id: 6,
    name: "Fideicomiso Desarrollo Integral",
    gestor: "AgroGlobal Partners",
    administrador: "Acción Fiduciaria",
    tipo: "Estructuración",
    categoria: "Estructuración",
    descripcion: "Fideicomiso orientado a proyectos de estructuración y desarrollo integral de activos inmobiliarios que combinan comercio, vivienda y oficinas, con inversiones diversificadas en múltiples sectores.",
    valor_unidad: 80000,
    tir_anual: 11,
    color: "#27AE60",
    imagen: require("../assets/images/AgroindustrialPlus.jpg"),
    unidades_disponibles: 120000000,
    negociable: true,
    nuevo: false
  }
];

// 🔹 Inversiones del usuario (coherentes con los fideicomisos)
export const INVERSIONES_USUARIO = [
  {
    id: 1,
    fund: 1,
    created_at: "2025-01-15 10:30:00",
    fecha_compra: "15/01/2025",
    invested_amount: 5000000, // 50 unidades x 100,000
    unidades: 50,
    rendimientos_acumulados: 250000, // 5% de 5,000,000 (6 meses)
    rendimientos_pendientes: 250000,
    fondoInfo: FIDEICOMISOS[0]
  },
  {
    id: 2,
    fund: 2,
    created_at: "2025-02-10 12:15:00",
    fecha_compra: "10/02/2025",
    invested_amount: 3000000, // 30 unidades x 100,000
    unidades: 30,
    rendimientos_acumulados: 150000, // 5% de 3,000,000 (5 meses)
    rendimientos_pendientes: 150000,
    fondoInfo: FIDEICOMISOS[1]
  },
  {
    id: 3,
    fund: 3,
    created_at: "2025-03-05 14:00:00",
    fecha_compra: "05/03/2025",
    invested_amount: 7000000, // 70 unidades x 100,000
    unidades: 70,
    rendimientos_acumulados: 350000, // 5% de 7,000,000 (4 meses)
    rendimientos_pendientes: 350000,
    fondoInfo: FIDEICOMISOS[2]
  }
];

// 🔹 Totales calculados
export const TOTALES = {
  total_invertido: INVERSIONES_USUARIO.reduce((acc, inv) => acc + inv.invested_amount, 0), // 15,000,000
  total_unidades: INVERSIONES_USUARIO.reduce((acc, inv) => acc + inv.unidades, 0), // 150
  total_rendimientos: INVERSIONES_USUARIO.reduce((acc, inv) => acc + inv.rendimientos_acumulados, 0), // 750,000
  tir_portafolio: 10, // TIR promedio ponderado
  rendimientos_ultimo_mes: 150000 // Último mes de rendimientos
};

// 🔹 Movimientos (historial completo de transacciones)
export const MOVIMIENTOS = [
  // Compras iniciales
  {
    id: 1,
    tipo: "compra",
    movimiento: "Compra de unidades",
    proyecto_c: "Fideicomiso Amarillo",
    fund_id: 101,
    fecha: "15/01/2025",
    saldo: 5000000,
    unidades: 50,
    status: "completado",
    descripcion: "Inversión inicial en Fideicomiso Amarillo"
  },
  {
    id: 2,
    tipo: "compra",
    movimiento: "Compra de unidades",
    proyecto_c: "Fideicomiso Verde",
    fund_id: 102,
    fecha: "10/02/2025",
    saldo: 3000000,
    unidades: 30,
    status: "completado",
    descripcion: "Inversión inicial en Fideicomiso Verde"
  },
  {
    id: 3,
    tipo: "compra",
    movimiento: "Compra de unidades",
    proyecto_c: "Fideicomiso Azul",
    fund_id: 103,
    fecha: "05/03/2025",
    saldo: 7000000,
    unidades: 70,
    status: "completado",
    descripcion: "Inversión inicial en Fideicomiso Azul"
  },
  
  // Rendimientos mensuales - Fideicomiso Amarillo (desde enero)
  {
    id: 4,
    tipo: "rendimiento",
    movimiento: "Pago de rendimientos",
    proyecto_c: "Fideicomiso Amarillo",
    fund_id: 101,
    fecha: "31/01/2025",
    saldo: 41667,
    status: "completado",
    descripcion: "Rendimientos mes de enero"
  },
  {
    id: 5,
    tipo: "rendimiento",
    movimiento: "Pago de rendimientos",
    proyecto_c: "Fideicomiso Amarillo",
    fund_id: 101,
    fecha: "28/02/2025",
    saldo: 41667,
    status: "completado",
    descripcion: "Rendimientos mes de febrero"
  },
  {
    id: 6,
    tipo: "rendimiento",
    movimiento: "Pago de rendimientos",
    proyecto_c: "Fideicomiso Amarillo",
    fund_id: 101,
    fecha: "31/03/2025",
    saldo: 41667,
    status: "completado",
    descripcion: "Rendimientos mes de marzo"
  },
  {
    id: 7,
    tipo: "rendimiento",
    movimiento: "Pago de rendimientos",
    proyecto_c: "Fideicomiso Amarillo",
    fund_id: 101,
    fecha: "30/04/2025",
    saldo: 41667,
    status: "completado",
    descripcion: "Rendimientos mes de abril"
  },
  {
    id: 8,
    tipo: "rendimiento",
    movimiento: "Pago de rendimientos",
    proyecto_c: "Fideicomiso Amarillo",
    fund_id: 101,
    fecha: "31/05/2025",
    saldo: 41667,
    status: "completado",
    descripcion: "Rendimientos mes de mayo"
  },
  {
    id: 9,
    tipo: "rendimiento",
    movimiento: "Pago de rendimientos",
    proyecto_c: "Fideicomiso Amarillo",
    fund_id: 101,
    fecha: "30/06/2025",
    saldo: 41665,
    status: "completado",
    descripcion: "Rendimientos mes de junio"
  },
  
  // Rendimientos mensuales - Fideicomiso Verde (desde febrero)
  {
    id: 10,
    tipo: "rendimiento",
    movimiento: "Pago de rendimientos",
    proyecto_c: "Fideicomiso Verde",
    fund_id: 102,
    fecha: "28/02/2025",
    saldo: 25000,
    status: "completado",
    descripcion: "Rendimientos mes de febrero"
  },
  {
    id: 11,
    tipo: "rendimiento",
    movimiento: "Pago de rendimientos",
    proyecto_c: "Fideicomiso Verde",
    fund_id: 102,
    fecha: "31/03/2025",
    saldo: 25000,
    status: "completado",
    descripcion: "Rendimientos mes de marzo"
  },
  {
    id: 12,
    tipo: "rendimiento",
    movimiento: "Pago de rendimientos",
    proyecto_c: "Fideicomiso Verde",
    fund_id: 102,
    fecha: "30/04/2025",
    saldo: 25000,
    status: "completado",
    descripcion: "Rendimientos mes de abril"
  },
  {
    id: 13,
    tipo: "rendimiento",
    movimiento: "Pago de rendimientos",
    proyecto_c: "Fideicomiso Verde",
    fund_id: 102,
    fecha: "31/05/2025",
    saldo: 25000,
    status: "completado",
    descripcion: "Rendimientos mes de mayo"
  },
  {
    id: 14,
    tipo: "rendimiento",
    movimiento: "Pago de rendimientos",
    proyecto_c: "Fideicomiso Verde",
    fund_id: 102,
    fecha: "30/06/2025",
    saldo: 25000,
    status: "completado",
    descripcion: "Rendimientos mes de junio"
  },
  
  // Rendimientos mensuales - Fideicomiso Azul (desde marzo)
  {
    id: 15,
    tipo: "rendimiento",
    movimiento: "Pago de rendimientos",
    proyecto_c: "Fideicomiso Azul",
    fund_id: 103,
    fecha: "31/03/2025",
    saldo: 58333,
    status: "completado",
    descripcion: "Rendimientos mes de marzo"
  },
  {
    id: 16,
    tipo: "rendimiento",
    movimiento: "Pago de rendimientos",
    proyecto_c: "Fideicomiso Azul",
    fund_id: 103,
    fecha: "30/04/2025",
    saldo: 58333,
    status: "completado",
    descripcion: "Rendimientos mes de abril"
  },
  {
    id: 17,
    tipo: "rendimiento",
    movimiento: "Pago de rendimientos",
    proyecto_c: "Fideicomiso Azul",
    fund_id: 103,
    fecha: "31/05/2025",
    saldo: 58333,
    status: "completado",
    descripcion: "Rendimientos mes de mayo"
  },
  {
    id: 18,
    tipo: "rendimiento",
    movimiento: "Pago de rendimientos",
    proyecto_c: "Fideicomiso Azul",
    fund_id: 103,
    fecha: "30/06/2025",
    saldo: 58334,
    status: "completado",
    descripcion: "Rendimientos mes de junio"
  },

  // Rendimientos pendientes de enero 2026
  {
    id: 19,
    tipo: "rendimiento",
    movimiento: "Pago de rendimientos",
    proyecto_c: "Fideicomiso Amarillo",
    fund_id: 101,
    fecha: "31/01/2026",
    saldo: 41667,
    status: "pendiente",
    descripcion: "Rendimientos mes de enero 2026"
  },
  {
    id: 20,
    tipo: "rendimiento",
    movimiento: "Pago de rendimientos",
    proyecto_c: "Fideicomiso Verde",
    fund_id: 102,
    fecha: "31/01/2026",
    saldo: 25000,
    status: "pendiente",
    descripcion: "Rendimientos mes de enero 2026"
  },
  {
    id: 21,
    tipo: "rendimiento",
    movimiento: "Pago de rendimientos",
    proyecto_c: "Fideicomiso Azul",
    fund_id: 103,
    fecha: "31/01/2026",
    saldo: 58333,
    status: "pendiente",
    descripcion: "Rendimientos mes de enero 2026"
  }
];

// 🔹 Funciones de utilidad
export const getInversionesByFund = (fundId) => {
  return INVERSIONES_USUARIO.filter(inv => inv.fund === fundId);
};

export const getMovimientosByFund = (fundId) => {
  return MOVIMIENTOS.filter(mov => mov.fund_id === fundId);
};

export const getInversionesAgrupadas = () => {
  // Agrupa inversiones por fondo
  return INVERSIONES_USUARIO;
};

export const getTotalInvertidoPorFondo = (fundId) => {
  const inversiones = getInversionesByFund(fundId);
  return inversiones.reduce((acc, inv) => acc + inv.invested_amount, 0);
};

export const getTotalRendimientosPorFondo = (fundId) => {
  const inversiones = getInversionesByFund(fundId);
  return inversiones.reduce((acc, inv) => acc + inv.rendimientos_acumulados, 0);
};
